import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { AnnouncementDto } from './models/AnnouncementDto';
import { AnnouncementSearchCriteria } from './models/AnnouncementSearchCriteria';

class AnnouncementsService {

    public getList(criteria: AnnouncementSearchCriteria) {
        return Http.get<Paged<AnnouncementDto>>('announcements', criteria);
    }

    public getById(id: string) {
        return Http.get<AnnouncementDto>('announcements/' + id);
    }

    public getActive() {
        return Http.get<AnnouncementDto[]>('announcements/active');
    }

    public create(model: AnnouncementDto) {
        return Http.post<string>('announcements', model);
    }

    public update(model: AnnouncementDto) {
        return Http.put('announcements', model);
    }

    public remove(model: AnnouncementDto) {
        return Http.put('announcements/deactivate', model);
    }
}

export default new AnnouncementsService();
